import Hero from "../components/home/Hero";
import Marquee from "../components/home/Marquee";
import IntroSection from "../components/home/IntroSection";
import PortfolioBento from "../components/home/PortfolioBento";
import ValuesSection from "../components/home/ValuesSection";
import RigenerazioneSection from "../components/home/RigenerazioneSection";
import RigenerazioneMap from "../components/RigenerazioneMap";
import SpacesSection from "../components/home/SpacesSection";
import FutureOpenings from "../components/home/FutureOpenings";
import MilanMap from "../components/home/MilanMap";
import NewsTeaser from "../components/home/NewsTeaser";
import ContactCTA from "../components/home/ContactCTA";
import SEO from "../components/SEO";

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO
        path="/"
        description="Invest Hospitality — holding italiana per lo sviluppo e la gestione di hotel a Milano. 15 strutture operative, 5 nuove aperture entro il 2027."
      />
      <Hero />
      <Marquee />
      <IntroSection />
      <PortfolioBento />
      <ValuesSection />
      <RigenerazioneSection />
      <RigenerazioneMap />
      <SpacesSection />
      <MilanMap />
      <FutureOpenings />
      <NewsTeaser />
      <ContactCTA />
    </div>
  );
}
